import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef, HostListener, ElementRef } from '@angular/core';
import { AuthService } from "../core/auth.service";
import { nullSafe } from '../utils';
import { CommonService } from '../core/common.service';
import { Subscription } from 'rxjs';
import { DialogService } from 'src/app/core/dialog.service';
import { SignalRService } from "src/app/shared/Services/signal-r.service";
import { ConfigurationApi, ExitApi } from 'src/app/core/api.gen';
import { filter, finalize } from 'rxjs/operators';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { NavigationEnd, Router } from '@angular/router';



@Component({
  selector: '[eos-header]',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: []
})
export class HeaderComponent implements OnDestroy, OnInit {
  isDelgated = false;
  delegateSubscription: Subscription;
  notificationCount: number;
  userId: number;
  user: any;
  url: string;
  toast: any;
  dropdownRoutes: string[] = ['/recruitment', '/subcontractor']; // Add your dropdown routes here
  isActiveDropdown: boolean = false;
  expandedItem: string | null = null;
  isDropdownClose: boolean = false;
  @ViewChild('dropdown', { static: false, read: ElementRef }) dropdownElementRef: ElementRef;
  @ViewChild('dropdown') dropdown: NgbDropdown;
								  

  constructor(
    private authService: AuthService,
    private dialog: DialogService,
    private exitApi: ExitApi,
    private configurationService: ConfigurationApi,
    private commonService: CommonService,
    public signalRService: SignalRService,
	  private router: Router) {
									 
    this.delegateSubscription = this.commonService.delegateStatus$.subscribe(delegateStatus => {
      this.isDelgated = delegateStatus;
    });
  }
  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user_info'));
    this.userId = (this.user.userId);    
    this.commonService.isActiveVisaApprover = this.authService.ActiveUser?.activeRole === 'VisaApprover';
    if (this.user.roles.indexOf('ExitTeam') > 0) {
      this.getPendingNotification();
      // this.signalRService.startConnection();
      // this.signalRService.employeeDataListener("transerEmployeeData", this.userId, 'Exit');      
    }
    this.getServiceNowUrl();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.isActiveDropdown = this.dropdownRoutes.some(route => event.urlAfterRedirects.startsWith(route));
    });
  }

  ShowNotification() {
    this.dialog.showNotificationDetails(1);
  }

  get isAdmin(): boolean {
    return this.authService.checkUserRole("ADM");
  }

  get isTemplateEditor(): boolean {
    return this.authService.hasClaim("template-editor");
  }
  get isImmTemplateEditor(): boolean {
    return this.authService.hasClaim("imm-template-editor");
  }

  get isExitTemplateEditor(): boolean {
    return this.authService.hasClaim("exit-template-editor");
  }


  get loggedInUserDisplayName(): string {

    return nullSafe(() => this.authService.ActiveUser.displayName, this.authService.AdUserName);
  }


  get showUser(): boolean {
    return this.authService.isAuthSuccessfull;
  }

  showMenu(mid: string): boolean {
    return this.authService.isActiveFeature(mid) && this.authService.isAuthenticated;
  }

  get isAmendTask(): boolean {
    return this.authService.hasClaim("amend-tasks");
  }
  get isImmActivityEditor(): boolean {
    return this.authService.hasClaim("imm-activity-editor");
  }

  get isExitActivityEditor(): boolean {
    return this.authService.hasClaim("exit-activity-editor");
  }
   get isImmDocumentVisamapping(): boolean {
    return this.authService.hasClaim("imm-document-visamapping");
  }

  get isGovernanceDocumentTypeEditor(): boolean {
    return this.commonService.isActiveVisaApprover
      && this.authService.hasClaim("governance-documenttype-editor");
  }

  get isGovernanceActivityEditor(): boolean {
    return this.commonService.isActiveVisaApprover
      && this.authService.hasClaim("governance-activity-editor");
  }
 get  isGovTemplateEditor(): boolean {
    return this.commonService.isActiveVisaApprover
      && this.authService.hasClaim("governance-template-editor");
  }

  get isConfigDropdownPJC(): boolean {
    return this.authService.hasClaim("config-pjc-dropdowns");
  }
  get isConfigDropdownIMM(): boolean {
    return this.authService.hasClaim("config-imm-dropdowns");
  }
  get isConfigDropdownEXT(): boolean {
    return this.authService.hasClaim("config-exit-dropdowns");
  }									   
																 
   


  logout() {
    this.authService.logout();
    // this.router.navigateByUrl('/logout');
  }

  help() {
    const url = this.isAdmin ? 'assets/TMTUserManual_ImmigrationModule_V2.1.pdf' : 'assets/TMTUserManual_V2.1.pdf';
    window.open(url);
  }
 
  ngOnDestroy() {
    this.delegateSubscription.unsubscribe();
  }

  get isExit(): boolean {

    return this.commonService.isExit();
  }

  get isImmigration(): boolean {

    return this.commonService.isImmigration();
  }

  getPendingNotification() {
    this.exitApi.getNotificationCount(this.userId, 'Exit').subscribe(data => {
      this.notificationCount = data;
    });
  }

  serviceNow() {
    window.open(this.url);
  }

  getServiceNowUrl() {
    this.configurationService
      .getAppConfigValue("ServiceNowUrl")
      .pipe(finalize(() => { }))
      .subscribe(
        (resp) => {
          this.url = resp;
        }
      );
  }
  selectOption(option: string, event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
      this.expandedItem = this.expandedItem === option ? null : option;
      if (this.dropdown && !this.dropdown.isOpen()) {
      this.dropdown.open();
    }
  }

  closeDropdown(): void {
    this.expandedItem = null;
      if (this.dropdown && this.dropdown.isOpen()) {
      this.dropdown.close();
    }
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.dropdownElementRef) {
      return;
    }
    const isInsideDropdown = this.isClickInsideDropdown(event);
      if (this.dropdown.isOpen() && !isInsideDropdown) {
      this.closeDropdown();
    }
  }
  
  private isClickInsideDropdown(event: MouseEvent): boolean {
    const dropdownElement = this.dropdownElementRef.nativeElement;
    return dropdownElement.contains(event.target);
  }
}
